module.exports = __webpack_public_path__ + "img/mmi-not-found-404.bb51c778.png";